/// <amd-module name="Wit/SprintsHub/SprintsView/Components/Capacity/AddUserDialog" />
import * as React from "react";
import { getAllowedIdentityTypes } from "Wit/Common/Utilities/Identity";
import { useState } from "react";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { usePageContext } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { Icon } from "VSSUI/Icon";
import { IdentityPickerDropdown, IIdentity } from "VSSUI/IdentityPicker";
import * as Resources from "Wit/SprintsHub/SprintsView/Resources";
import { ICapacityService } from "Wit/SprintsHub/SprintsView/Services/ICapacityService";

export interface IAddUserDialogProps {
    onDismiss: () => void;
}

/**
 * This can safely be used in a .ts file without React.createElement
 */
export function renderAddUserDialog(props: IAddUserDialogProps) {
    return <AddUserDialog {...props} />;
}

export function AddUserDialog(props: IAddUserDialogProps) {
    const pageContext = usePageContext();
    const capacityService = pageContext.getService<ICapacityService>("ICapacityService");

    const [selectedUser, setSelectedUser] = useState<IIdentity | undefined>(undefined);
    const currentCapacities = capacityService.getMemberCapacities().value;

    let duplicate = false;

    if (currentCapacities.some(capacity => capacity.teamMember && selectedUser && capacity.teamMember.id === selectedUser.localId)) {
        duplicate = true;
    }

    const onConfirm = () => {
        capacityService.addUser(selectedUser!);
        props.onDismiss();
    };

    return (
        <Dialog
            onDismiss={props.onDismiss}
            footerButtonProps={[
                { disabled: selectedUser === undefined || duplicate, onClick: onConfirm, primary: true, text: Resources.Ok },
                { onClick: () => props.onDismiss(), text: Resources.Cancel }
            ]}
            titleProps={{ text: Resources.AddUser }}
        >
            <IdentityPickerDropdown
                pickerProvider={
                    new PeoplePickerProvider(pageContext, {
                        identityTypes: getAllowedIdentityTypes(pageContext, { excludeGroups: true }),
                    })
                }
                onChange={identity => {
                    setSelectedUser(identity);
                }}
                value={selectedUser}
            />
            {duplicate && (
                <div className="flex-row flex-center  error-text padding-4 font-size">
                    <Icon className="padding-right-4" iconName="Error" />
                    {Resources.DuplicateUserErrorMessage}
                </div>
            )}
        </Dialog>
    );
}
